/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsStreamDtoSchema = z.object({
  title: z.string().nullish(),
  viewers: z.optional(z.int()),
  game: z.string().nullish(),
  streamer: z.string().nullish(),
  isOnline: z.optional(z.boolean()),
  thumbnailUrl: z.string().nullish(),
  startedAt: z.optional(z.iso.datetime()),
});
